'use client'

import { useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

// Params that must not be carried when navigating away from match pages (e.g. sidebar, mobile nav).
// They are match-detail-specific; keeping them would wrongly hide the header on other pages.
const PARAMS_TO_DROP_ON_NAVIGATE = ['match_id', 'match_function_dialog', 'submit_lineup']

const useAddQueryToNewLink = () => {
    const searchParams = useSearchParams()

    const addQueryToNewLink = useCallback(
        (url: string) => {
            if (typeof window === 'undefined') return url // Return original URL if on server-side

            const urlObj = new URL(url, window.location.origin)
            searchParams?.forEach((value, key) => {
                if (PARAMS_TO_DROP_ON_NAVIGATE.includes(key)) return
                // Only add parameter if it doesn't already exist in the new URL
                if (!urlObj.searchParams.has(key)) {
                    urlObj.searchParams.append(key, value)
                }
            })
            return urlObj.pathname + urlObj.search
        },
        [searchParams]
    )

    return { addQueryToNewLink }
}

export default useAddQueryToNewLink
